import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import DepartmentServices from "../../../Services/DepartmentServices";
import DataParser from "../../../utlits/Dataparser";
import Sidebar from "../../Layouts/Sidebar";
import { toast } from "react-toastify";

const EditDepartment = () => {
  const location = useLocation();
  const departments = location.state.data;
  const [name, setName] = useState(departments.name);
  const company_id = DataParser.CompanyId();
  const navigate = useNavigate();
  const [isSending, setIsSending] = useState(false);
  const [error, setError] = useState("");

  // const onSubmitHandler = (e) => {
  //   const id = departments.id;
  //   setIsSending(true);
  //   e.preventDefault();
  //   try {
  //     const AddPackageData = {
  //       name: name,
  //       company_id: company_id,
  //     };
  //     DepartmentServices.editDepartment(id, AddPackageData).then((res) => {
  //       if (res.data === "Un-Athunticated request") {
  //         secureLocalStorage.removeItem("adminInfo");
  //         secureLocalStorage.removeItem("admins");
  //         navigate("/");
  //         setIsSending(false);
  //       }
  //       if (res.Good === true) {
  //         navigate(`/${DataParser.CompanyIdentifierRole()}/departments`);
  //         setIsSending(false);
  //       }
  //     });
  //   } catch (err) {}
  // };

  const onSubmitHandler = (e) => {
    e.preventDefault();

    if (name.trim() === "") {
      setError("Department name is required!");
      return; // stop submission
    }

    const id = departments.id;
    setIsSending(true);

    try {
      const AddPackageData = {
        name: name,
        company_id: company_id,
      };

      DepartmentServices.editDepartment(id, AddPackageData)
        .then((res) => {
          setIsSending(false);

          if (res.data === "Un-Athunticated request") {
            toast.error("Session expired! Please log in again.");
            secureLocalStorage.removeItem("adminInfo");
            secureLocalStorage.removeItem("admins");
            navigate("/");
            return;
          }

          if (res.Good === true) {
            toast.success("Department updated successfully!");
            navigate(`/${DataParser.CompanyIdentifierRole()}/departments`);
          } else {
            toast.warning("No changes detected or something went wrong.");
          }
        })
        .catch((err) => {
          setIsSending(false);
          console.error("Update error:", err);
          toast.error(
            err.response?.data?.message ||
            "An error occurred while updating the department."
          );
        });
    } catch (err) {
      setIsSending(false);
      console.error("Unexpected error:", err);
      toast.error("Unexpected error occurred. Please try again!");
    }
  };


  return (
    <>
      {/* <Sidebar /> */}
      <div className="main-content">
        <div className="page-content Pagebody">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    {/* Nav tabs */}
                    <ul className="nav nav-tabs" role="tablist">
                      <li className="nav-item">
                        <a
                          className="nav-link active"
                          data-bs-toggle="tab"
                          href="#navtabs-home"
                          role="tab"
                        >
                          <span className="d-block d-sm-none">
                            <i className="fas fa-home" />
                          </span>
                          <span className="d-none d-sm-block">
                            <i className="uil-user" />
                            &nbsp;General
                          </span>
                        </a>
                      </li>
                    </ul>
                    {/* Tab panes */}
                    <div className="tab-content p-3 text-muted">
                      <div
                        className="tab-pane active"
                        id="navtabs-home"
                        role="tabpanel"
                      >
                        <form onSubmit={(e) => onSubmitHandler(e)}>
                          <div className="mb-3">
                            <div className="col-6">
                              <label className="form-label" htmlFor="Name">
                                Department Name
                              </label>
                              <input
                                type="text"
                                onChange={(e) => {
                                  setName(e.target.value);
                                  if (e.target.value.trim() !== "") setError("");
                                }}
                                value={name}
                                className={`form-control ${error ? "is-invalid" : ""}`}
                                id="Name"
                                placeholder="Department Name"
                                
                              />
                              {error && (
                                <small className="text-danger">{error}</small>
                              )}
                            </div>
                            <div className="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                              <button
                                type="submit"
                                className="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1"
                              >
                              Create
                              </button>
                              <button
                                type="reset"
                                className="btn btn-light"
                                onClick={() => navigate(-1)}
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditDepartment;
